import { Capacitor } from '@capacitor/core';

const parseVersionParts = (value) => String(value || '')
  .split('.')
  .map((part) => Number.parseInt(part, 10))
  .map((part) => (Number.isFinite(part) ? part : 0));

const DEFAULT_REMOTE_ANDROID_MANIFEST_URL = 'https://www.robotbeheer-krinkels.nl/android-update.json';

export const compareVersions = (currentVersion, nextVersion) => {
  const currentParts = parseVersionParts(currentVersion);
  const nextParts = parseVersionParts(nextVersion);
  const maxLength = Math.max(currentParts.length, nextParts.length);

  for (let index = 0; index < maxLength; index += 1) {
    const current = currentParts[index] || 0;
    const next = nextParts[index] || 0;
    if (next > current) return 1;
    if (next < current) return -1;
  }

  return 0;
};

export const getAndroidUpdateManifestUrl = () => {
  const envUrl = process.env.REACT_APP_ANDROID_UPDATE_MANIFEST_URL;
  if (envUrl) return envUrl;

  try {
    const managedUrl = window.managedConfiguration?.android_update_manifest_url
      || window.managedConfiguration?.update_manifest_url
      || window.managedConfiguration?.apk_update_manifest_url;
    if (managedUrl) return managedUrl;
  } catch {
    // ignore managed config access failures
  }

  try {
    const mdmConfig = window.localStorage.getItem('mdm_config');
    if (mdmConfig) {
      const parsed = JSON.parse(mdmConfig);
      const storedManagedUrl = parsed?.android_update_manifest_url
        || parsed?.update_manifest_url
        || parsed?.apk_update_manifest_url;
      if (storedManagedUrl) return storedManagedUrl;
    }

    const localUrl = window.localStorage.getItem('androidUpdateManifestUrl');
    if (localUrl) return localUrl;
  } catch {
    // ignore storage failures
  }

  const isNativeAndroid = Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'android';

  // Native Android should use a remote manifest, not APK-bundled local assets.
  if (isNativeAndroid) {
    return DEFAULT_REMOTE_ANDROID_MANIFEST_URL;
  }

  // Default to hosting/public manifest so update checks work out of the box.
  return '/android-update.json';
};

export const resolveAndroidUpdateUrl = (assetUrl, manifestUrl) => {
  if (!assetUrl) return '';

  try {
    return new URL(assetUrl, manifestUrl || window.location.origin).toString();
  } catch {
    try {
      return new URL(assetUrl, window.location.origin).toString();
    } catch {
      return String(assetUrl);
    }
  }
};

export const isNewerAndroidBuild = ({ currentVersion, currentVersionCode, remoteVersion, remoteVersionCode }) => {
  const normalizedCurrentCode = Number(currentVersionCode || 0);
  const normalizedRemoteCode = Number(remoteVersionCode || 0);

  if (normalizedRemoteCode && normalizedCurrentCode && normalizedRemoteCode > normalizedCurrentCode) {
    return true;
  }

  if (remoteVersion && currentVersion) {
    return compareVersions(currentVersion, remoteVersion) === 1;
  }

  return false;
};